<!--负荷实时分析-->
<template>
	<div>
		<p class="bigTitle">工单分类</p>
		<div class="flexBetween">
			<p>类型:</p>
			<p v-for="item in typeList" :class="{isCheck:nowType == item}" @click="nowType = item">{{item}}</p>
		</div>
		<vchart style="height: calc(100% - 80px);margin-top: 10px;" themes="UbiquitousOverviewChartSkin" ref='vchart'></vchart>
	</div>
</template>

<script>
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			vchart
		},
		props: {},
		data() {
			return {
				nowType: "抢修",
				typeList: ["抢修", "检修", "巡检", "实验", "工程", "托管"],
				options: {},
			}
		},
		created() {},
		mounted() {
			//初始化图表
			this.options = this.$refs.vchart.getDefaultOptions()
			this.options.title.show = false
			this.options.grid = {
				top: 10,
				bottom: 30,
				left: 10,
				right: 10
			}
			this.options.xAxis.nameTextStyle = {
				color: "white"
			}
			this.options.toolbox.show = false
			this.options.legend.show = false
			// this.$refs.vchart.setData(this.options, true)
			this.initData()
		},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {
			initData() {
				var today = []
				var now = new Date().getMonth() + 1
				for (var i = 1; i <= now; i++) {
					today.push([i + "月", 100 + (i % 5 * 2)])
				}
				var legend = ["工单数量"]
				var seriesList = [{
					name: "工单数量",
					type: 'bar',
					smooth: true,
					symbol: 'emptyCircle',
					sampling: 'average',
					data: today,
				}]
				this.options.series = seriesList
				this.options.legend.data = legend
				this.$refs.vchart.setData(this.options, true)
			}
		}
	}
</script>

<style scoped>
	.orderBar p.bigTitle {
		width: 100%;
		color: #00C6FF;
		font-size: 18px;
		font-weight: bold;
		text-align: center;
		margin-top: 15px;
		margin-bottom: 14px;
	}

	.orderBar p {
		color: white;
	}

	.orderBar .flexBetween {
		width: 90%;
		margin-left: 5%;
	}

	.orderBar .flexBetween p {
		padding: 2px 8px;
		cursor: pointer;
	}

	.isCheck {
		background: #0C90FF;
		border-radius: 11px;
	}
</style>
